import React from 'react'
import ReseetPin from '../../Components/Otp/ResetPin'

function ResetPin() {
  return (
    <div className='bg-signin-bg'>
    <div className='  grid w-10/12 md:w-8/12   mx-auto h-[100vh] place-items-center'>
   
     <ReseetPin/>
    </div>
    </div>
  )
}

export default ResetPin